import { csvParse } from 'omni-campaign-ui';
import { rfcColors } from '../campaign-audience-viz/campaign-audience-rfc-legend.js';

// Hardcoded role for comms data. Stored as CSV to make it easier to modify and more compact.
// In theory this won't change any time soon, and eventually should live in omni dictionary or similar as reference data.
const csvData = `
channel,activity,ad_format,activating,impacting,building,reinforcing
TV,,,0,1,1,1
Social media,,,1,1,1,1
Search,,,1,0,0,0
Print,,,1,0,0,0
Print,Direct Mail,,1,1,0,0
Print,Magazine,,1,0,0,1
Print,Newspapers,,1,0,0,1
Outdoor,,,0,1,0,1
Digital video,,,0,1,1,1
Digital video,DV360,,1,1,1,1
Digital video,Programmatic,,1,1,1,1
Digital video,Twitch,,1,1,1,1
Digital video,Yahoo,,1,1,1,1
Digital video,Youku,,1,1,1,1
Digital video,YouTube,,1,1,1,1
Digital display,,,1,0,0,1
Cinema,,,0,1,1,1
Audio,,,0,1,1,1
Affiliates,,,1,0,1,0`;

// Transform the data for easy lookup
const lookup = {};
csvParse(csvData.trim()).forEach(row => {
  const channelActivity = `${row.channel}${
    row.activity ? `-${row.activity}` : ''
  }`;
  lookup[channelActivity] = {
    activating: row.activating === '1',
    impacting: row.impacting === '1',
    building: row.building === '1',
    reinforcing: row.reinforcing === '1',
  };
});

export const rfcColor = (channel, activity, role) => {
  if (!role) return undefined;
  const match = lookup[`${channel}-${activity}`] ?? lookup[channel];
  if (!match || !match[role]) return undefined;
  return rfcColors[role];
};
